<template>
  <div class="direct-messages-wrap" :class="{ mobile: mobile }">
    <dmlist
      v-if="(!directChat && mobile) || !mobile"
      v-on:selected="goToDM"
      @resetchatprop="resetChatProp"
      :gotoprofile="userid"
      :orientation="orientation"
      :mobile="mobile"
      @getRolId="handleGetRolId"
    />
    <msglist
      v-if="!mobile || directChat"
      :directchat="directChat"
      v-on:report="bubbleReport"
      @goback="goBack"
      :orientation="orientation"
      :mobile="mobile"
      :rolId="rolId"
    />
  </div>
</template>

<script>
import dmlist from "./DMList.vue";
import msglist from "./MsgList.vue";
export default {
  components: {
    dmlist,
    msglist,
  },
  props: {
    userid: Number,
    orientation: Boolean,
    mobile: Boolean,
  },
  data() {
    return {
      directChat: null,
      rolId:null
    };
  },
  mounted() {
    this.$emit("dmselected", false);
  },
  methods: {
    resetChatProp() {
      this.$emit("resetchatprop");
    },
    goBack() {
      this.$emit("goback");
    },
    bubbleReport(msg) {
      this.$emit("report", msg);
    },
    goToDM(dmInfo) {
      // handles what DM user has clicked and sends it to message list component
      this.directChat = dmInfo;
      this.$emit("dmselected", true);
    },
    handleGetRolId(rolId) {
      if(!rolId) return
      this.rolId = rolId;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.direct-messages-wrap {
  @include flex-start;
  height: calc(100% - 80px);
  width: 100%;
  &.mobile {
    flex-direction: column;
    height: calc(100% - 40px);
  }
}
</style>